export default "__VITE_ASSET__FMdqu1zE__"